import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetDocumentosEntreguesUseCase } from "../../../presentation/useCases/read/get_documentos_entregues_use_case";
import { DocumentoEntregue } from "../../models/documento_entregue";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetDocumentoEntreguesUseCase
 */

export class GetDocumentosEntreguesUseCase extends BasePaginatedUseCase<DocumentoEntregue> implements IGetDocumentosEntreguesUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getDocumentosEntregues(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getDocumentosEntregues(
      idFuncionario,
      page,
      pageSize,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}